export enum Questionary {
  Unset,
  Yes,
  No,
}
